// src/services/api.js
const API_BASE_URL = 'https://ircserver.quikbilling.online/api';

const api = {
  request: async (url, method = 'GET', body = null) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds timeout

    try {
      const headers = {
        'Content-Type': 'application/json',
      };

      const token = localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const config = {
        method,
        headers,
        signal: controller.signal,
      };

      if (body) {
        config.body = JSON.stringify(body);
      }

      const response = await fetch(`${API_BASE_URL}${url}`, config);
      clearTimeout(timeoutId);

      // Check if response has content
      const contentType = response.headers.get('content-type');
      let data;
      
      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        // If no JSON content, create a simple response object
        data = { 
          status: response.status,
          statusText: response.statusText,
          ok: response.ok
        };
      }

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (err) {
      clearTimeout(timeoutId);
      if (err.name === 'AbortError') {
        throw new Error('Request timeout');
      }
      throw err;
    }
  },

  get: (url) => api.request(url),
  post: (url, body) => api.request(url, 'POST', body),
  put: (url, body) => api.request(url, 'PUT', body),
  delete: (url) => api.request(url, 'DELETE'),
};

export default api;